import React, {createRef} from 'react'
import {findDOMNode} from "react-dom"
import HintPopover from "../../../../core/gd-ui/hint-popover/hint-popover"
import Popover from "../../../../core/gd-components/gd-popover/popover"
import MoreMenuStandardOption, {MoreButtonOptionType} from "./standard-option"
import MoreMenuCustomOption from "./custom-option"
import ExportToPdfOption from "./components/export-pdf"
import ControlButtonStandard, {ControlButtonType} from "../../../../core/gd-components/buttons/control-button/control-button-standard"

type Props = {
    options             : any[]

    onTogglePopover?    : {(value:boolean):void}
}

type State = {
    showPopover : boolean
}

export enum AppControlMoreOptions {

    SEPARATOR   = 'separator',
    EXPORT_PDF  = 'export-pdf',
    // EXPORT_CSV  = 'export-csv',
    // EXPORT_PNG  = 'export-png',
    // PRINT       = 'print',

}


export default class AppControlMore extends React.Component<Props,State> {

    private hintPopoverRef: React.RefObject<any> = createRef()

    state = {
        showPopover: false
    }

    showPopover = () => {
        if (!this.state.showPopover) {
            this.setState({
                showPopover: true
            }, ()=>{
                this.hintPopoverRef.current.hide()
                this.props.onTogglePopover && this.props.onTogglePopover(this.state.showPopover)
            })
        }
    }
    hidePopover = () => {
        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            }, ()=>{
                this.props.onTogglePopover && this.props.onTogglePopover(this.state.showPopover)
            })
        }
    }

    renderPopover() {
        const onClick = (menuOption:any) => {
            this.hidePopover();
            menuOption.onClick();
        }

        let exportIconShown = false;
        const exportTypes = ['export-pdf', 'export-csv', 'export-png']

        return (
            <Popover popoverClass="gd-view-more-popover"
                     getTargetFunc={()=>findDOMNode(this)}
                     attachment="top right"
                     targetAttachment="bottom right"
                     attachmentType="horizontal"
                     onClickOutside={()=>{this.hidePopover()}}>

                <div className="ui5-popover-menu min-w-200">
                    {this.props.options.map((menuOption, key)=>{

                        if (menuOption === AppControlMoreOptions.SEPARATOR) {
                            return <div key={key} className="separator"/>
                        }

                        if (menuOption === 'export-pdf' || menuOption === MoreButtonOptionType.EXPORT_PDF || menuOption.type === MoreButtonOptionType.EXPORT_PDF) {
                            // return <ExportToPdfOption key={key} hideIcon={exportIconShown} hidePopover={this.hidePopover}/>;
                            return <ExportToPdfOption key={key} hideIcon={false} hidePopover={this.hidePopover} onClick={menuOption.onClick}/>;
                        }

                        let res;
                        /*if (menuOption === 'export-pdf')           res = <ExportToPdfOption key={key} hideIcon={exportIconShown} hidePopover={this.hidePopover}/>;
                        else */if (exportTypes.includes(menuOption.type)) res = <MoreMenuStandardOption key={key} option={menuOption} hideIcon={exportIconShown} onClick={onClick}/>;
                        else if (menuOption.type) {
                            res = <MoreMenuStandardOption key={key} option={menuOption} onClick={onClick}/>;
                        } else {
                            res = <MoreMenuCustomOption key={key} option={menuOption} onClick={onClick}/>
                        }

                        if (!exportIconShown && (exportTypes.includes(menuOption) || exportTypes.includes(menuOption.type))) exportIconShown = true;

                        return res;
                    })}
                </div>
            </Popover>
        );
    }

    render() {
        const classes = Classes({
            "show-popover": this.state.showPopover
        });

        return (
            <ControlButtonStandard className={classes} type={ControlButtonType.MORE} onClick={this.showPopover}>
                {this.state.showPopover && this.renderPopover()}
                <HintPopover ref            = {this.hintPopoverRef}
                             hint           = "More options"
                             checkShowHint  = {()=>!this.state.showPopover}/>
            </ControlButtonStandard>
        )
    }
}
